import { type SetComplexImmerStateAction, type Task } from '@/lib/types';
import { createContext } from 'react';

const TaskContext = createContext<[Task, SetComplexImmerStateAction<Task>]>([
  null as unknown as Task,
  () => {},
]);

export default TaskContext;
